import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CheckCircleGreen: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="16" height="16" rx="8" fill="white" />
    <path
      d="M4.00182 12.205C3.91152 7.87186 7.19396 4.36498 11.3364 4.02744C15.9447 3.65192 19.8184 7.17851 19.9937 11.6765C20.165 16.0828 16.8345 19.58 12.7651 19.9637C8.13354 20.4005 4.13871 16.8381 4.00182 12.205ZM11.0085 12.8124C10.9222 12.7325 10.8781 12.6941 10.8365 12.6526C10.4363 12.252 10.0378 11.8499 9.63643 11.4508C9.26411 11.0803 8.72516 11.0623 8.37327 11.406C8.01636 11.7546 8.02567 12.3061 8.39979 12.6827C9.02151 13.3083 9.64468 13.9325 10.27 14.5545C10.7383 15.0203 11.2153 15.0164 11.684 14.5477C12.9737 13.2581 14.2634 11.9685 15.5523 10.6786C15.6072 10.6238 15.6627 10.5689 15.71 10.508C15.9791 10.1615 15.9501 9.67815 15.6437 9.36641C15.2865 9.00272 14.7525 9.00916 14.3705 9.39006C13.2941 10.4632 12.2201 11.5385 11.1472 12.6149C11.0935 12.6687 11.0576 12.7414 11.0085 12.8124Z"
      fill="#44C688"
    />
  </svg>
);
